

















import { Component, Vue } from "vue-property-decorator";
import ExtendsImageContent from "@/components/ExtendsImageContent.vue";

@Component({
  components: { 
    ExtendsImageContent
  }
})
export default class ExtendsImageTabsContent extends Vue {

  tabList: Array<{ key: 'car' | 'seibi'; label: string }> = [
    {key: 'car', label: '車両画像'},
    {key: 'seibi', label: '整備画像'}
  ];
  currentTabKey: 'car'|'seibi' = 'car';
  tabDisabled: boolean = false;

  selectTab(key: 'car'|'seibi') {
    if (key === this.currentTabKey) {
      return;
    }
    this.currentTabKey = key;
  }

  onModeChanged(mode: 0|1|2) {
    this.tabDisabled = mode !== 0;
  }

}
